import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';

import { Icons } from './theme/components/Icons';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import { Form } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
import LoyaltyV2 from '@websky/core/src/CheckoutAdditionalService/components/LoyaltyV2/LoyaltyV2';
import Stepbar from '@websky/core/src/BaseComponents/Stepbar';
import PriceDetailsExtendedVariant from '@websky/core/src/LEO/Refund/PriceDetails/components/PriceDetailsExtendedVariant/PriceDetailsExtendedVariant';
import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon';
import { PriceDetailsShortVariant } from '@websky/core/src/__fsd__/entities/order';
import SeatInfoGroup from './components/SeatInfoGroup/SeatInfoGroup';

export const renders: EngineRenderers = {
	...Icons,
	CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
	BaggageIcon,
	CheckoutForm: props => <Form {...props} showCheckDataModal={true} />,
	CheckoutLoyalty: LoyaltyV2,
	CheckoutDesktopStepbar: props => <Stepbar {...props} variant="textOnly" />,
	PriceDetails: PriceDetailsExtendedVariant,
	RefundPrices: PriceDetailsShortVariant,
	SeatInfoGroup
};
